import { Flex, Box, Button } from 'components/ui';
import eulerClubBg from 'img/euler-club-bg.png';
import ebHeadphonesCircled from 'img/eb-headphones-circled.png';

const EulerClubSection = () => {
  return (
    <Box
      width="100%"
      padding={['40px 16px', '40px']}
      backgroundImage={`url(${eulerClubBg})`}
      backgroundSize="cover"
      backgroundPosition="0 95%"
      borderBottom="1px solid white"
    >
      <Flex
        justifyContent="space-between"
        flexDirection={['column', 'row', 'row']}
      >
        <Box mb={3}>
          <h2>EULERCLUB</h2>
          <Box mb={4}>
            Check out our place in the CryptoVoxels Metaverse.
          </Box>
          <Button
            onClick={() => window.location.assign('https://www.cryptovoxels.com/play?coords=NW@580W,263N')}
            outlined
          >
            Visit
          </Button>
        </Box>

        <Box width="240px">
          <Box mb={3} fontSize="16px">
            Claim your EB headphones to unlock access to the club
          </Box>
          <img src={ebHeadphonesCircled} alt="EB Headphones" width="240px" />
        </Box>
      </Flex>
    </Box>
  )
}

export default EulerClubSection;
